import { extractStoragePublicPath } from "./supabaseStoragePublicUrl";

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const UUID_GLOBAL_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/ig;

function normalizeProfileImageRef(raw?: string | null): string | null {
  if (!raw || typeof raw !== "string") return null;
  const value = raw.trim();
  if (!value || value.includes("undefined") || value === "/default-media.png") return null;
  return value;
}

function extractComparablePath(raw: string): string {
  const fromPublicUrl = extractStoragePublicPath(raw);
  const withoutQuery = (fromPublicUrl ?? raw).split("?")[0].replace(/^\/+/, "");
  return decodeURIComponent(withoutQuery);
}

function extractStorageOwnerId(raw: string): string | null {
  const parts = extractComparablePath(raw).split("/").filter(Boolean);
  for (let index = 0; index < parts.length; index += 1) {
    const folder = parts[index]?.toLowerCase();
    const next = parts[index + 1] ?? "";
    if ((folder === "user-media" || folder === "user-covers") && UUID_RE.test(next)) {
      return next;
    }
    if (folder === "avatars") {
      const avatarOwner = next.match(UUID_GLOBAL_RE)?.[0] ?? null;
      if (avatarOwner) return avatarOwner;
    }
  }
  return null;
}

export function extractForeignProfileImageOwnerId(raw?: string | null, ownerUserId?: string | null): string | null {
  const value = normalizeProfileImageRef(raw);
  const owner = ownerUserId?.trim();
  if (!value || !owner || !UUID_RE.test(owner)) return null;

  const storageOwnerId = extractStorageOwnerId(value);
  if (!storageOwnerId || storageOwnerId.toLowerCase() === owner.toLowerCase()) return null;
  return storageOwnerId;
}

export function isProfileImageOwnedByUser(raw?: string | null, ownerUserId?: string | null): boolean {
  const value = normalizeProfileImageRef(raw);
  if (!value) return false;
  return extractForeignProfileImageOwnerId(value, ownerUserId) == null;
}

export function keepOwnedProfileImageUrl<T extends { url?: string | null }>(
  item: T | null | undefined,
  ownerUserId?: string | null,
): T | undefined {
  if (!item?.url || !isProfileImageOwnedByUser(item.url, ownerUserId)) return undefined;
  return item;
}
